import { operatorColors } from '~/utils/operatorColors';
import { CustomInputDrop } from '~/utils/CustomInputDrop';
import { CustomHandle } from '~/utils/CustomHandle';

// Node de radiciação (ⁿ√a)
export const OperatorRadicalNode = ({ data, notNode = false, onDataChange }) => {
    const isVertical = (data?.layout || 'vertical') === 'vertical';
    // Função para lidar com a mudança dos drops de entrada
    const handleIndexChange = (newDrop) => onDataChange({ indexDrop: newDrop, radicandDrop: data.radicandDrop });
    const handleRadicandChange = (newDrop) => onDataChange({ indexDrop: data.indexDrop, radicandDrop: newDrop });
    
    return (
        <div className="node-operator-radical" style={{ 
            display: 'flex', 
            flexDirection: isVertical ? 'column' : 'row',
            alignItems: isVertical ? 'center' : 'flex-end', 
            justifyContent: 'center',
            gap: '2px',
            width: '100%',
            position: 'relative'
        }}>
            {/* Índice da raiz (número pequeno em cima à esquerda) */}
            <div style={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'flex-start',
                position: 'relative'
            }}>
                <div style={{ 
                    marginBottom: '4px', 
                    transform: 'scale(0.7)', 
                    transformOrigin: 'left bottom',
                    position: 'relative',
                    top: '-6px'
                }}>
                    <CustomInputDrop 
                        dropData={data.indexDrop || { id: 'index', type: null, data: {} }} 
                        dropId="index" 
                        onDropChange={handleIndexChange} 
                        style={{ fontSize: '11px' }}
                    />
                </div>
            </div>
            
            {/* Símbolo de raiz */}
            <div style={{
                background: operatorColors['Radiciação'] || '#17a2b8',
                color: 'white',
                borderRadius: '6px',
                padding: '6px 10px',
                fontWeight: 'bold',
                fontSize: '16px',
                minWidth: '35px',
                textAlign: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                √
            </div>
            
            {/* Radicando (número dentro da raiz) */}
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <CustomInputDrop 
                    dropData={data.radicandDrop || { id: 'radicand', type: null, data: {} }} 
                    dropId="radicand" 
                    onDropChange={handleRadicandChange} 
                />
            </div>
            
            {!notNode && <CustomHandle type="target" position="top" connectionCount={1} />}
            {!notNode && <CustomHandle type="source" position="bottom" connectionCount={1} />}
        </div>
    );
};